import { functions } from '../config/firebase';
import { httpsCallable } from 'firebase/functions';

export async function createUser({ email, fullName, role, roles, fundAccess, streamAccess }) {
  const fn = httpsCallable(functions, 'createUser');
  // Pass both role (string, primary) and roles (array) so the Cloud Function
  // can use the full roles array for multi-role support
  const result = await fn({ email, fullName, role, roles, fundAccess, streamAccess });
  return result.data;
}

export async function updateUserRole({ uid, roles }) {
  const fn = httpsCallable(functions, 'updateUserRole');
  // Pass roles as an array; the Cloud Function handles both old (newRole string)
  // and new (roles array) formats
  const result = await fn({ uid, roles });
  return result.data;
}

export async function deactivateUser({ uid }) {
  const fn = httpsCallable(functions, 'deactivateUser');
  const result = await fn({ uid });
  return result.data;
}

export async function initializeCountryRegistry() {
  const fn = httpsCallable(functions, 'initializeCountryRegistry');
  const result = await fn();
  return result.data;
}

export async function checkSetupStatus() {
  const fn = httpsCallable(functions, 'checkSetupStatus');
  const result = await fn();
  return result.data;
}

export async function createFirstAdmin({ email, password, fullName }) {
  const fn = httpsCallable(functions, 'createFirstAdmin');
  const result = await fn({ email, password, fullName });
  return result.data;
}
